import i18n from "@/i18n";

export default {
  validate(value) {
    return value.match(/^([a-zA-Z0-9. _-])+$/i);
  },
  message: i18n.t("integrations.error.not_valid_fqdn")
};
